import { searchIndicesV3, searchIndicesV4 } from './searchIndices';
export function resolveAlgoliaSearchIndex(environment) {
  let enableV4SearchIndexFlagValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let indexSuffix = arguments.length > 2 ? arguments[2] : undefined;
  const index = enableV4SearchIndexFlagValue ? searchIndicesV4 : searchIndicesV3;
  return "".concat(index[environment].indexName).concat(indexSuffix ? "_".concat(indexSuffix) : '');
}